export default "__VITE_ASSET__lY0ZWKQG__"